import Request from './request/ReferralInfoRequestInitialState'

const { Record } = require('immutable')

export default Record({
    request: Request()
})